<div id="box" #resizableBox [class.bounding-box]="mode === 'boundingBox'">
  <span #tl id="tl" class="corner-handle"></span>
  <span #tr id="tr" class="corner-handle"></span>
  <span #bl id="bl" class="corner-handle"></span>
  <span #br id="br" class="corner-handle"></span>

  <span #moveArea id="moveArea" mat-button> </span>
</div>
